/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespDetails_item = {
    readonly serviceId: string | null;
    readonly pdpDetailsDisplay: ReadonlyArray<{
        readonly detailKey: string | null;
        readonly delimiter: string | null;
        readonly detailDisplayName: string | null;
        readonly detailValues: ReadonlyArray<{
            readonly " $fragmentRefs": FragmentRefs<"PdpSharedDetail_detailValues">;
        } | null> | null;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDetailFramingOptions_item" | "PdpSharedDetailReference_item">;
    readonly " $refType": "PdpRespDetails_item";
};
export type PdpRespDetails_item$data = PdpRespDetails_item;
export type PdpRespDetails_item$key = {
    readonly " $data"?: PdpRespDetails_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespDetails_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespDetails_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PdpDetail",
      "kind": "LinkedField",
      "name": "pdpDetailsDisplay",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "detailKey",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "delimiter",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "detailDisplayName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "detailValues",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpSharedDetail_detailValues"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailFramingOptions_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailReference_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = 'bc158b584a053ea1bd056a197e79cf01';
export default node;
